import { type SpecialCondition } from '@reliance/types/models/SpecialCondition';
import { type ApiService, type QueryParams } from '../types/ApiService';

type ConditionsResponse = {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
  results: SpecialCondition[];
};

export const condition = (centralApi: ApiService) => ({
  index: (params: QueryParams = {}): Promise<ConditionsResponse> => {
    return centralApi.get<ConditionsResponse>(`/condition`, {
      params,
    });
  },
});
